import React from 'react'

import { Divider } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { func, object, string } from 'prop-types'

import { NOOP } from 'Utils/stableDefaults'

import Suggestion from './Suggestion'

function Suggestions({ suggestions = null, onKeywordClick = NOOP, locale = 'en' }) {
  if (!suggestions) {
    return null
  }

  const {
    keywordsInCategory = [],
    keywords = [],
    items,
    searchKeyword,
  } = suggestions

  const shouldShowDivider = keywordsInCategory.length > 0 && keywords.length > 0
  const hasKeywordsInCategory = keywordsInCategory && keywordsInCategory.length > 0
  const hasKeywords = keywords && keywords.length > 0

  return (
    <div className="new-search__suggestions cgt-effect-card-border-grey-thin">
      <ul className="new-search__suggestions-list">
        {hasKeywordsInCategory && keywordsInCategory.map(({ keyword, categoryTitle, thumbnailUrl }) => (
          <Suggestion
            key={keyword}
            type="keywordsInCategory"
            {...{
              keyword,
              categoryTitle,
              thumbnailUrl,
              locale,
            }}
          />
        ))}

        {hasKeywords && keywords.map(({ suggestedKeyword, thumbnailUrl }) => (
          <Suggestion
            key={suggestedKeyword}
            type="category"
            {...{
              suggestedKeyword,
              searchKeyword,
              onKeywordClick,
              thumbnailUrl,
            }}
          />
        ))}

        {items && (
          <>
            {shouldShowDivider && (
              <Divider customClass="new-search__suggestions-divider" />
            )}
            {items.map(({ itemTitle, itemThumbnailImage, thumbnailUrl }) => (
              <Suggestion
                key={itemTitle}
                type="item"
                {...{
                  itemTitle,
                  itemThumbnailImage,
                  thumbnailUrl,
                }}
              />
            ))}
          </>
        )}
      </ul>
    </div>
  )
}

Suggestions.propTypes = {
  suggestions: object,
  onKeywordClick: func,
  locale: string,
}

export default Suggestions
